import {cloneDeep} from 'lodash';
import {createImageObject} from '@/store/utils';
import * as marketFormater from '@/views/ImageCreate/utils/formate';
import {formConfig} from '@/views/Image/stitching/utils/formConfig.js';
import {defaultFormData} from '@/views/Image/stitching/utils/formData.js';
import {getImagePositionInfo} from '@/views/Image/stitching/utils/format.js';

export default {
    namespaced: true,
    state: {
        title: '多图拼接',
        placeHolder: {
            page: 'stitching',
            title: '图片拼接',
            subtitle: '点击左侧上传图片，按照选择的模板为您智能拼接图片',
            src: 'https://qiaojiang.bj.bcebos.com/fe/static/images/concat_video.mp4'
        },
        displayImg: [],
        recordImg: [],
        toolBarLoading: false,
        formConfig: cloneDeep(formConfig),
        formData: cloneDeep(defaultFormData),
        canSubmit: true,
        sizeValidate: true,
        historyParams: {
            pageNo: 1,
            pageSize: 10,
            taskType: [17]
        },
        pageLoadingStatus: {
            show: false,
            title: ''
        }
    },
    mutations: {
        UPDATE_COMMON_STATE(state, {key, value}) {
            state[key] = value;
        },
        UPDATE_FORM_DATA(state, {form, key, value}) {
            state[form] = {...state[form], [key]: value};
        },
        CHANGE_CAN_SUBMIT(state, data) {
            state.canSubmit = data;
        },
        CHANGE_SIZE_VALIDATE(state, data) {
            state.sizeValidate = data;
        },
        CHANGE_RECORD_IMG(state, data) {
            state.recordImg = data;
        },
        CHANGE_DISPLAY_IMG(state, data) {
            state.displayImg = data;
        },
        CHANGE_TOOLBAR_LOADING(state, data) {
            state.toolBarLoading = data;
        },
        CHANGE_PAGE_STATUS(state, data) {
            state.pageLoadingStatus = data;
        }
    },
    actions: {
        updateFormData({commit}, data) {
            const {key, value} = data;
            if (key === 'sizeControl') {
                if (value && value.type === 'custom') {
                    const {value: innerValue} = value;
                    if (innerValue && innerValue.customTips) {
                        commit('CHANGE_SIZE_VALIDATE', false);
                    }
                    else {
                        commit('CHANGE_SIZE_VALIDATE', true);
                    }
                }
                else {
                    commit('CHANGE_SIZE_VALIDATE', true);
                }
            }
            commit('UPDATE_FORM_DATA', {
                form: 'formData',
                key,
                value
            });
        },
        updateCommonState({commit}, {key, value}) {
            commit('UPDATE_COMMON_STATE', {
                key,
                value
            });
        },
        changeFormSubmit({commit}, data) {
            commit('CHANGE_CAN_SUBMIT', Boolean(data.length));
        },
        changeDisplayImg({commit}, data) {
            commit('CHANGE_DISPLAY_IMG', data);
        },
        changePageStatus({commit}, data) {
            commit('CHANGE_PAGE_STATUS', data);
        },
        resetFromData({commit}) {
            const value = cloneDeep(defaultFormData);
            commit('UPDATE_COMMON_STATE', {
                key: 'formData',
                value
            });
            commit('CHANGE_TOOLBAR_LOADING', false);
        },
        // 获取创作纪录
        async getHistory({commit, state}, model) {
            try {
                const res = await model.imageCreate.getHistory(state.historyParams);
                const recordImgList = res.listData.map(i => {
                    const recordList = i.records;
                    return recordList;
                }).filter(item => item !== undefined);

                commit('CHANGE_RECORD_IMG', recordImgList);
            }
            catch (err) {
                throw err;
            }
        },
        // 图片拼接按钮提交
        async handleStitchingSubmit({commit, state}, {model, data}) {
            commit('CHANGE_TOOLBAR_LOADING', true);
            try {
                const baseDisplayImg = Array.from({
                    length: data.targetCount
                }, (_, i) => createImageObject({
                    recordId: i
                }));
                commit('CHANGE_DISPLAY_IMG', baseDisplayImg);

                const {layoutNum, uploadList, itemSize, space, targetCount, imageGenerateType} = data;

                const canvasStyle = {
                    height: data.height,
                    width: data.width
                };

                let mergeGroups = [];

                // 选择多张图片，合成多张图片，需要先按顺序进行分组，分配给每张图片用的拼接源
                let groupImageList = [];
                uploadList.forEach((imageItem, index) => {
                    const sizeParam = itemSize[index % layoutNum];
                    const imageInfo = getImagePositionInfo({
                        sizeParam,
                        imageItem,
                        space,
                        canvasStyle
                    });
                    groupImageList.push(imageInfo);
                    // 如果本组已经够数了，push记录，然后清空，继续下一组
                    if (groupImageList.length === layoutNum) {
                        mergeGroups.push(groupImageList);
                        groupImageList = [];
                    }
                });
                // 对每一组图片，进行拼接合成的动作，组合出多个合成结果
                const mergeImagesResult = await Promise.all(
                    mergeGroups.map(async groupImageList => {
                        let groupInfo = await model.imageCreate.renderImagesByCanvas(canvasStyle, groupImageList);
                        groupInfo.editorParams = JSON.stringify({
                            itemSize,
                            space,
                            canvasStyle,
                            imageList: groupImageList
                        });
                        return groupInfo;
                    })
                );
                if (mergeImagesResult.length < 1) {
                    throw new Error();
                }
                // 对这批图片生成结果，调用后端接口存储起来
                const taskParams = {
                    ...canvasStyle,
                    targetCount,
                    imageGenerateType,
                    extraParams: {
                        formData: state.formData
                    }
                };
                const saveInfoList = marketFormater.handleSaveInfo(mergeImagesResult, taskParams);
                const infoList = await model.imageCreate.insertGenMarketPicture(saveInfoList);

                const displayImg = infoList.map(item => createImageObject(item));

                commit('CHANGE_DISPLAY_IMG', displayImg);
            }
            catch (err) {
                commit('CHANGE_DISPLAY_IMG', []);
                throw err;
            }
            finally {
                commit('CHANGE_TOOLBAR_LOADING', false);
            }
        },
        // 修改了某张图片的调整拼接顺序等，需要重新合成图片 ，然后更新结果区的信息
        async changeSourceImageList({commit, state}, {model, recordInfo, imageList, index}) {
            // 根据调整后的图片list，合成新的图片，并更新record，更新结果区，更新历史区
            const {height, width, recordId} = recordInfo;
            const canvasStyle = {
                height,
                width
            };
            const editorParamsObj = JSON.parse(recordInfo.editorParams);
            const {itemSize, space} = editorParamsObj;
            // 重新计算每个图片的坐标信息
            const newImageList = imageList.map((imageItem, index) => {
                const sizeParam = itemSize[index];
                return getImagePositionInfo({
                    sizeParam,
                    imageItem,
                    space,
                    canvasStyle
                });
            });
            let editorParams = JSON.parse(recordInfo.editorParams);
            editorParams.imageList = newImageList;
            const newInfo = await model.imageCreate.renderImagesByCanvas(canvasStyle, newImageList);
            const newUrl = newInfo.url;
            let updateRecord = {
                recordId,
                editorParams: JSON.stringify(editorParams),
                url: newUrl
            };
            // 更新record、然后更新结果和历史
            model.imageCreate.updateCutoutRecord({
                recordList: [updateRecord]
            });
            recordInfo.url = newUrl;
            recordInfo.editorParams = updateRecord.editorParams;

            const nowDisplayImg = state.displayImg;
            nowDisplayImg[index].url = newUrl;
            nowDisplayImg[index].editorParams = updateRecord.editorParams;
            commit('CHANGE_DISPLAY_IMG', nowDisplayImg);
        }
    },
    getters: {
    }
  };
